const EmptyFieldItem = () => {
  const uniHyphen = `\u2014`;
  return <span className="text-specialGray-075 font-semibold">{uniHyphen}</span>;
};

export default EmptyFieldItem;
